<template>
  <div class="row mt-5">
    <div class="col-md-3"></div>
    <div class="col-md-6">
      <div class="w-100 d-flex flex-column align-items-center" v-if="loading">
        <v-loader/>
        <div class="mt-2">
          {{ $t('phrase.please_wait') }}
        </div>
      </div>
      <transition name="fade-down">
        <div
          v-if="!loading"
          class="card"
        >
          <div class="card-body">
            <h3>{{ $t('phrase.removed_from_research') }}</h3>
            <p class="text-muted">
              {{ $t('sentence.removed_from_research_explanation') }}
            </p>

            <div class="alert alert-warning m-0">
              <i class="fa fa-warning"></i>
              {{ $t('sentence.removed_from_research_warning') }}
            </div>
          </div>
          <div class="card-footer">
            <router-link
              :to="{ name: 'dashboard' }"
              class="btn btn-primary btn-block"
            >
              {{ $t('phrase.back_to_dashboard') }}
            </router-link>
          </div>
        </div>
      </transition>
    </div>
    <div class="col-md-3"></div>
  </div>
</template>

<script>
import Loader from '@/common/components/Loader.vue';

export default {
  name: 'RemovedFromResearchView',
  components: {
    'v-loader': Loader,
  },
  data() {
    return {
      loading: true,
    };
  },
  created() {
    setTimeout(() => {
      this.loading = false;
    }, 900);
  },
};
</script>
